import KEY from '../enums/key.js';

export const tabSelectors = {
  focusable:
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]',
};

export class TabTrapper {
  constructor(container) {
    this.container = container;
    this.focusableElements = this.container.querySelectorAll(
      tabSelectors.focusable
    );

    this.init();
  }

  init() {
    this.focusFirstFocussableElement();
    this.registerEventListeners();
  }

  focusFirstFocussableElement() {
    if (this.focusableElements.length > 0) {
      this.focusableElements[0].focus();
    }
  }

  registerEventListeners() {
    if (this.focusableElements.length > 0) {
      const [firstFocusableElement] = this.focusableElements;
      const lastFocusableElement =
        this.focusableElements[this.focusableElements.length - 1];

      this.keyboardHandler = event => {
        if (event.key === KEY.TAB) {
          if (
            event.shiftKey &&
            document.activeElement === firstFocusableElement
          ) {
            event.preventDefault();
            lastFocusableElement.focus();
          } else if (
            !event.shiftKey &&
            document.activeElement === lastFocusableElement
          ) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      };

      this.container.addEventListener('keydown', this.keyboardHandler);
    }
  }

  close() {
    this.container.removeEventListener('keydown', this.keyboardHandler);
  }
}
